import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Page title
document.title = 'Inteligencia Social Estratégica';
// Meta tags helper
const setMeta = (property: string, content: string) => {
  let el = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};
const setMetaName = (name: string, content: string) => {
  let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};
const TITLE = 'Inteligencia Social Estratégica';
const DESC = 'El sistema para detectar engaños, dominar conversaciones y ganar respeto instantáneo.';
const IMG = 'https://cdn.magicpatterns.com/uploads/jq4oCouCmrcu5LgrGg5Vut/ChatGPT_Image_23_feb_2026,_13_39_58.png';
setMeta('og:title', TITLE);
setMeta('og:description', DESC);
setMeta('og:image', IMG);
setMeta('og:type', 'website');
setMetaName('twitter:title', TITLE);
setMetaName('twitter:description', DESC);
setMetaName('twitter:card', 'summary_large_image');
setMetaName('twitter:image', IMG);
// ===== META PIXEL ID: 1927478928649366 =====
const PIXEL_ID = '1927478928649366';
// Initialize fbq queue before script loads
const w = window as any;
if (!w.fbq) {
  const n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  w._fbq = n;
  n.push = n;
  n.loaded = false;
  n.version = '2.0';
  n.queue = [];
}
// Queue init and PageView (will execute once script loads)
w.fbq('init', PIXEL_ID);
w.fbq('track', 'PageView');
// Load the Facebook pixel script
const pixelScript = document.createElement('script');
pixelScript.async = true;
pixelScript.src = 'https://connect.facebook.net/en_US/fbevents.js';
document.head.appendChild(pixelScript);
// Noscript fallback pixel image
const noscript = document.createElement('noscript');
const img = document.createElement('img');
img.height = 1;
img.width = 1;
img.style.display = 'none';
img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
noscript.appendChild(img);
document.body.appendChild(noscript);
// Also add the img directly for environments that strip noscript
const fallbackImg = document.createElement('img');
fallbackImg.height = 1;
fallbackImg.width = 1;
fallbackImg.style.display = 'none';
fallbackImg.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
document.body.appendChild(fallbackImg);
render(<App data-id="element-328" />, document.getElementById('root'));